import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464b0004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "first-space" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "汇聚优质服务商，", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "共助教育生态健康发展", -1))
const _hoisted_6 = { class: "senior-btn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "second-space" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("h1", null, [
      /*#__PURE__*/_createElementVNode("span", null, "简单四步，轻松入驻")
    ]),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "填写基础资料"),
      /*#__PURE__*/_createElementVNode("li", null, "提交资质信息"),
      /*#__PURE__*/_createElementVNode("li", null, "提供结算账户"),
      /*#__PURE__*/_createElementVNode("li", null, "完成合同签署")
    ])
  ])
], -1))
const _hoisted_8 = { class: "third-space" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "立即入驻，一起为教育生态的健康发展保驾护航", -1))
const _hoisted_11 = { class: "on-mobile" }
const _hoisted_12 = { class: "product-tab" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "theme-word" }, "八爪优服", -1))
const _hoisted_14 = { class: "grounds" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "汇聚优质服务商", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "共助教育生态健康发展", -1))
const _hoisted_17 = { class: "btns" }
const _hoisted_18 = { class: "steps" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "phone-product-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "简单四步，轻松入驻")
], -1))
const _hoisted_20 = { class: "together" }
const _hoisted_21 = { class: "container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "立即入驻，一起为教育生态的健康发展保驾护航", -1))

import SpecialButton from '@/components/SpecialButton.vue';
  import { ref, onMounted } from 'vue';
  import { useRouter } from "vue-router";
  import { useStore } from "vuex";
  import { key } from "@/store";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'serve',
  setup(__props) {

  let store = useStore(key);
  const router = useRouter();

  // PC端-服务商入驻
  const toPage = ()=>{
    store.commit("settledActive",{flag: true, type: 2});
  }

  // 移动端-跳转路由
  const targetPage = (name:string)=>{
    router.push({ name });
  }
  // 移动端-咨询弹窗
  const counsellingPhoneActive = (flag:boolean)=>{
      store.commit("counsellingPhoneShow",flag);
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SpecialButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("线下地推服务商")
              ]),
              _: 1
            }),
            _createVNode(SpecialButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toPage()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("线上运营服务商")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            class: "white-border-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toPage()))
          }, "立即入驻")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("ul", _hoisted_12, [
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (targetPage('consumer')))
        }, "八爪畅学用户端"),
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (targetPage('mechanism')))
        }, "八爪畅学机构端"),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "phone-product-btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (counsellingPhoneActive(true)))
          }, "线下地推服务商"),
          _createElementVNode("button", {
            class: "phone-product-btn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (counsellingPhoneActive(true)))
          }, "线上运营服务商")
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['填写基础资料','提交资质信息','提供结算账户','完成合同签署'], (text, k) => {
            return _createElementVNode("li", { key: k }, _toDisplayString(text), 1)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("button", {
            class: "phone-product-white-btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (counsellingPhoneActive(true)))
          }, "立即入驻")
        ])
      ])
    ])
  ], 64))
}
}

})